/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Severity level information
 * @export
 * @interface SeverityInfo
 */
export interface SeverityInfo {
    /**
     * Severity name
     * @type {string}
     * @memberof SeverityInfo
     */
    name?: string;
    /**
     * Severity display name
     * @type {string}
     * @memberof SeverityInfo
     */
    displayName?: string;
    /**
     * Severity description
     * @type {string}
     * @memberof SeverityInfo
     */
    description?: string;
    /**
     * Severity level (numeric for sorting)
     * @type {number}
     * @memberof SeverityInfo
     */
    level?: number;
    /**
     * Color code for UI display
     * @type {string}
     * @memberof SeverityInfo
     */
    color?: string;
}

/**
 * Check if a given object implements the SeverityInfo interface.
 */
export function instanceOfSeverityInfo(value: object): value is SeverityInfo {
    return true;
}

export function SeverityInfoFromJSON(json: any): SeverityInfo {
    return SeverityInfoFromJSONTyped(json, false);
}

export function SeverityInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'level': json['level'] == null ? undefined : json['level'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function SeverityInfoToJSON(json: any): SeverityInfo {
    return SeverityInfoToJSONTyped(json, false);
}

export function SeverityInfoToJSONTyped(value?: SeverityInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'level': value['level'],
        'color': value['color'],
    };
}

